export default "__VITE_ASSET__dd0f24a1__"